import Http from '../http';
import axios from 'axios';

export const apiUrl = () => {
  const baseURLs = {
    'local':'https://s-checkout.builderall.com', 
    'io'   :'https://supercheckout.kub.app.builderall.io', 
    'info' :'https://supercheckout.kub.app.builderall.info', 
    'com'  :'https://s-checkout.builderall.com' 
  }

  const host = window.location.host;

  const keyMatch = Object.keys(baseURLs).find(key => host.includes(key)) || 'io';

  return baseURLs[keyMatch];
};

const softcache = {};

class Api {
  constructor(token = null) {
    let headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };

    if (token) headers['Authorization'] = `Bearer ${token}`;

    this.http = axios.create({
      baseURL: apiUrl() + '/api',
      headers
    });
    this.softcache = {};
  }

  get(path, options = {}) {
    return this.http.get(path, options);
  }

  post(path, options) {
    return this.http.post(path, options);
  }

  patch(path, options) {
    return this.http.patch(path, options);
  }

  delete(path, options) {
    return this.http.delete(path, options);
  }
}

export const auth = (id, language, cache = true) => {
  // if (!softcache[`${id}-${language}-token`] || cache === false)
    softcache[`${id}-${language}-token`] = Http.authApi().post(`supercheckout/auth`, {id, language});

  return softcache[`${id}-${language}-token`];
};

export const clearCache = (token, name) => {
  if (!softcache[`${token}-${name}`])
    return;

  delete softcache[`${token}-${name}`];
};

export const getProducts = token => {
  return new Api(token).get('products?has-resume=1');
};
export const getSellable = (type, hash) => {
  return new Api().get(`${type}/${hash}`);
};

export const getAllProducts = token => {
  return new Api(token).get('products?has-resume=1');
};

export const getSiteInfo = (token, cache = true) => {
  if (!softcache[`${token}-info`] || cache === false)
    softcache[`${token}-info`] = new Api(token).get('info');

  return softcache[`${token}-info`];
};

export const getCountries = (token) => {
  if (!softcache[`${token}-info`])
    softcache[`${token}-countries`] = new Api(token).get('countries');

  return softcache[`${token}-countries`];
};

export const removePaymentConfig = (token, hash) => {
  return new Api(token).delete(`user/user-gateways/${hash}`);
};

export const savePaymentConfig = (token, data) => {
  let url = data[data.type].hash
    ? `/user/gateways/${data.type}/${data[data.type].hash}`
    : `/user/gateways/${data.type}`;

  return new Api(token)[data[data.type].hash ? 'patch' : 'post'](url, data[data.type]);
};

export const saveBussiness = (token, info) => {
  info.basic = true;
  return new Api(token).post('user/business', info);
};

const productData = data => ({
  name: data.name,
  description: data.description,
  status: 1,
  format_id: data.format,
  niche_id: data.niche,
  versions: [
    {
      name: data.name,
      image: data.image,
      price: parseInt(`${data.price}`.replace('.', '')), // inteiro
      currency: data.currency,
      always_address: data.askAddress,
      language: data.language,
      thank_you_page_url: data.thankYouPage,
      sales_page_url: data.salesPage,
      status: 1,
      refund_period: data.refundPeriod,
      payment_type: data.type,
      payment_options: data.paymentOptions,
      template_id: data.template_id || 5
    }
  ]
});

export const getProduct = (token, hash) => {
  return new Api(token).get(`products/${hash}`);
};

export const saveProduct = (token, data) => {
  let options = productData(data);
  if (data.hash) {
    options.hash = data.hash;
    options.versions[0].id = data.versionId;
    return new Api(token).patch(`products/${data.hash}`, options);
  }

  return new Api(token).post('products', options);
};



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/supercheckout.js